import { Optional } from '@mews/std';
import UserImage from '../../../../../../legacy/React/Components/Common/UserImage';

export interface UserProfileAvatarProps {
    enterpriseImageId: Optional<string>;
    enterpriseName?: string;
    isEmployee?: boolean;
    userEmail?: string;
    userFullName: string;
    userImageId?: string;
    useBigEnterpriseImage?: boolean;
}

const UserProfileAvatar = ({
    enterpriseName,
    enterpriseImageId,
    isEmployee,
    userEmail,
    userFullName,
    userImageId,
    useBigEnterpriseImage,
}: UserProfileAvatarProps) => {
    const enterpriseImageProps = {
        altText: enterpriseName,
        imageId: enterpriseImageId,
    };

    const userImageProps = {
        altText: userFullName || userEmail,
        imageId: userImageId,
    };

    let props = {};

    if (isEmployee) {
        if (useBigEnterpriseImage) {
            props = enterpriseImageProps;
        } else {
            props = {
                ...userImageProps,
                subAltText: enterpriseImageProps.altText,
                subImageId: enterpriseImageProps.imageId,
            };
        }
    } else {
        props = userImageProps;
    }

    // @ts-expect-error $TSFixMeError: Property 'altText' is missing in type '{}' but required in type 'Omit<Props, never>'.
    return <UserImage {...props} />;
};

export default UserProfileAvatar;
